import { IGcpAppDispatch } from "../../redux/store";
import config from "../../config";
import { performSignedRequest } from "../../redux/modules/auth/asyncActions";

export interface IMaidenScan {
  // Either "maiden-scan" for the drone maiden or "satellite-maiden-YYYY-MM-DD" for a satellite one
  folder: string;
  orthophotoTilesPath: string;
  // Null when the maiden has no DEM, which is always the case for satellite maidens
  elevationMapTilesPath: string | null;
}

export const isSatelliteMaiden = (maiden: IMaidenScan): boolean =>
  maiden.folder.startsWith("satellite-maiden");

export const fetchMaidenScan =
  (customerId: string, siteId: string) =>
  async (dispatch: IGcpAppDispatch): Promise<IMaidenScan> => {
    const url = `${config.endpoints.backofficeApiV2}/${customerId}/${siteId}/maiden-scans`;
    const resp = await dispatch(
      performSignedRequest(
        {
          method: "GET",
          url,
        },
        customerId,
        siteId,
      ),
    );
    // The drone maiden goes first, satellite maidens follow it ordered by scan date
    const [maiden] = resp.data?.maidens ?? [];
    if (!maiden) {
      throw new Error(`Invalid response ${resp.data}`);
    }
    return maiden;
  };
